// libs
import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// widgets
import Tile from '@/widgets/Tile';
import PerformanceSummaryTable from './components/PerformanceTable';
// constants
import { DlsFontVariants, DlsColorTokens } from '@/constants/DLSTokens';
// styles
import styles from './PerformanceSummary.module.scss';
const PerformanceSummary = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Tile, { className: styles.tile },
            React.createElement("div", { className: styles.tableTitleContainer },
                React.createElement("div", { className: styles.header },
                    React.createElement(Text, { variant: DlsFontVariants.header_H4_Black, color: DlsColorTokens.text_Highest_Emphasis }, "Performance Summary")),
                React.createElement("div", { className: cx(styles.table, props.className) },
                    React.createElement(PerformanceSummaryTable, Object.assign({}, props)))))));
};
export default PerformanceSummary;
